import { Injectable } from '@angular/core';
import { OauthAdapter } from './oauth.adapter';

@Injectable({
  providedIn: 'root',
})
export class LeerIdAdapter extends OauthAdapter {
  protected provider = 'leerid';

  constructor() {
    super();
  }
}

